<template>
  <div>
        <shelvesStore2 :isshow.sync='productFlag' v-if="productFlag" :excludeList='tableData' @onClick='saveret' :config="config" :keyItem='keyItem'>
            <el-table-column
            :prop="keyItem"
            label="商品id"
            width="150">
          </el-table-column>
          <el-table-column
            prop="name"
            label="商品名"
            width="300"
            >
          </el-table-column>
          <el-table-column  :label="$t('message.商品图片')" width="300" >
              <template slot-scope="scope">
                  <el-popover v-if="scope.row.img != ''" placement="top-start" title="" trigger="hover" @show='showimg'>
                    <img :src="'' + scope.row.img" alt="" style="max-width: 500px; max-height: 500px">
                    <img slot="reference" :src="'' + scope.row.img" style="max-width: 120px; max-height: 30px">
                  </el-popover>
                  <span v-else>{{$t('message.无')}}</span>
              </template>
            </el-table-column>
        </shelvesStore2>
    <el-button size="medium" round  @click="selectProduct" :disabled="!isModify">
              选择商品
    </el-button>
    <div style="height:20px"></div>
    <el-table
          ref="table"
          :data="tableData"
          stripe
          border
          style="width: 800px">
          <el-table-column
            fixed
            label="No."
            type="index"
            width="55">
          </el-table-column>
          <el-table-column fixed width="80" :label="$t('message.操作')" align="center">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" round type="normal" icon="el-icon-delete" @click="deleteTableDate(scope,scope.index)" :disabled="!isModify"></el-button>
              </el-button-group>
            </template>
          </el-table-column>
          <el-table-column
            :prop="keyItem"
            label="商品id"
            align="center"
            show-overflow-tooltip
            width="100">
          </el-table-column>
          <el-table-column
            prop="name"
            label="商品名"
            align="center"
            min-width="150"
            show-overflow-tooltip
            >
          </el-table-column>
          <el-table-column
            prop="quantity"
            label="数量"
            align="center"
            min-width="200"
            show-overflow-tooltip
            >
             <template slot-scope="scope">
              <el-input-number @input="setValue(scope.$index,'quantity',$event)"  v-model="scope.row.quantity" size="mini"  :disabled='!isModify' />
            </template>
          </el-table-column>
    </el-table>
  </div>
</template>

<script>
import shelvesStore2 from "@/components/productStore/shelvesStore2";
export default {
    name:'chooseGoods',
    components: {
    shelvesStore2,
  },
     props: {
    // 是否使用复选
    isModify: {
      type: Boolean,
      default: true,
    },
    tableData:{
        type:Array,
        default:[]
    },
    activityid:{
      type:Number,
      default:0
    }
     },
    data(){
        return {
            productFlag:false,
            config:{
                slot:true,
                posturl:'/manage/commodity/getcommoditylist'
            },
            keyItem:'commodityid',
        }
    },
    methods:{
        setValue(i,k,r){
          let v=JSON.parse(JSON.stringify(this.tableData))
          v[i][k]=r
          this.$emit('update:tableData',v)
        },
        selectProduct(){
            
            this.productFlag=true
        },
        deleteTableDate(e,r){
            console.log(e,r)
            let v=JSON.parse(JSON.stringify(this.tableData))
           
            v.splice(e.$index,1)
            let h=[]

             v.forEach(item => {
              h.push({
                commodityid:item.commodityid,
                name:item.name,
                masterid:0,
                quantity:item.quantity?item.quantity:0
              })
            });
            this.$emit('update:tableData',h)

        },
        saveret(e){
            // this.tableData=this.tableData.concat(e.sel)
            
            let v=JSON.parse(JSON.stringify(this.tableData))
            console.log(e)
            let h=[]

             v.forEach((item,index) => {
              h.push({
                commodityid:item.commodityid,
                name:item.name,
                masterid:0,
                quantity:item.quantity?item.quantity:0
              })
            });
             e.sel.forEach(item => {
              h.push({
                commodityid:item.commodityid,
                name:item.name,
                masterid:0,
                quantity:0
              })
            });
            console.log(h)
            this.$emit('update:tableData',h)
            // this.$emit('update:tableData',v.concat(e.sel))
        },
        
    },
    mounted(){
        console.log('查看tableDate',this.tableData)
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/elementSelect/chooseGoods.vue